import { render, staticRenderFns } from "./DeleteIcon.vue?vue&type=template&id=1fa807fc"
import script from "./DeleteIcon.vue?vue&type=script&lang=ts"
export * from "./DeleteIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports